function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["prefixClassName", "position", "containerStyle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { createRoot } from 'react-dom/client';
import AlertCard from "./AlertCard";
import { positions, groupBy, types } from "./options";
import useShowAndRemove from "./useShowAndRemove";
var AlertInstance = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "tui-alert" : _ref$prefixClassName,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? positions.TOP_RIGHT : _ref$position,
    _ref$containerStyle = _ref.containerStyle,
    containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    alerts = _useState2[0],
    setAlerts = _useState2[1];
  var _useShowAndRemove = useShowAndRemove(_objectSpread({
      prefixClassName: prefixClassName,
      position: position,
      containerStyle: containerStyle
    }, props), setAlerts),
    show = _useShowAndRemove.show,
    remove = _useShowAndRemove.remove;
  useImperativeHandle(ref, function () {
    return {
      add: function add(alert) {
        show(alert);
      },
      "delete": function _delete(key) {
        remove(key);
      }
    };
  });
  var alertsByPosition = groupBy(alerts, function (alert) {
    return alert.position;
  });
  return Object.values(positions).map(function (position) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, " ").concat(position),
      style: containerStyle,
      key: position
    }, alertsByPosition[position] ? alertsByPosition[position].map(function (alert) {
      return /*#__PURE__*/React.createElement(AlertCard, _extends({
        prefixClassName: prefixClassName
      }, alert, {
        key: alert.key,
        onClose: function onClose() {
          return remove(alert.key);
        },
        position: position,
        hasTransition: true
      }), alert.message);
    }) : null);
  });
});
AlertInstance.displayName = "AlertInstance";
AlertInstance.propTypes = {
  prefixClassName: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  position: PropTypes.oneOf(Object.values(positions)),
  containerStyle: PropTypes.object
};
var Alert = function () {
  var instance;
  var innerAlert;
  var root; // add this

  function configureAlert() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    instance = document.createElement("div");
    document.body.appendChild(instance);
    function ref(alert) {
      if (!innerAlert) {
        innerAlert = alert;
      }
    }
    root = createRoot(instance);
    root.render(/*#__PURE__*/React.createElement(AlertInstance, _extends({}, props, {
      ref: ref
    })));
  }
  if (!instance) {
    configureAlert();
  }
  return {
    config: function config(properties) {
      if (!instance) {
        configureAlert(properties);
      }
    },
    show: function show(alertProps) {
      var _innerAlert;
      if (innerAlert && (_innerAlert = innerAlert) !== null && _innerAlert !== void 0 && _innerAlert.add) {
        innerAlert.add(_objectSpread(_objectSpread({}, alertProps), {}, {
          type: types.DEFAULT
        }));
      }
    },
    success: function success(alertProps) {
      var _innerAlert2;
      if (innerAlert && (_innerAlert2 = innerAlert) !== null && _innerAlert2 !== void 0 && _innerAlert2.add) {
        innerAlert.add(_objectSpread(_objectSpread({}, alertProps), {}, {
          message: alertProps.message,
          type: types.SUCCESS
        }));
      }
    },
    error: function error(alertProps) {
      var _innerAlert3;
      if (innerAlert && (_innerAlert3 = innerAlert) !== null && _innerAlert3 !== void 0 && _innerAlert3.add) {
        innerAlert.add(_objectSpread(_objectSpread({}, alertProps), {}, {
          message: alertProps.message,
          type: types.ERROR
        }));
      }
    },
    info: function info(alertProps) {
      var _innerAlert4;
      if (innerAlert && (_innerAlert4 = innerAlert) !== null && _innerAlert4 !== void 0 && _innerAlert4.add) {
        innerAlert.add(_objectSpread(_objectSpread({}, alertProps), {}, {
          message: alertProps.message,
          type: types.INFO
        }));
      }
    },
    warning: function warning(alertProps) {
      var _innerAlert5;
      if (innerAlert && (_innerAlert5 = innerAlert) !== null && _innerAlert5 !== void 0 && _innerAlert5.add) {
        innerAlert.add(_objectSpread(_objectSpread({}, alertProps), {}, {
          message: alertProps.message,
          type: types.WARNING
        }));
      }
    },
    remove: function remove(key) {
      var _innerAlert6;
      if (innerAlert && (_innerAlert6 = innerAlert) !== null && _innerAlert6 !== void 0 && _innerAlert6["delete"]) {
        innerAlert["delete"](key);
      }
    },
    destroy: function destroy() {
      if (root) {
        root.unmount();
      }
      if (instance && instance.parentNode) {
        instance.parentNode.removeChild(instance);
      }
      instance = null;
      innerAlert = null;
      root = null;
    }
  };
}();
export default Alert;
//# sourceMappingURL=Alert.js.map